var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.row.routedBy))]),_vm._v(" "),(_vm.row.routedBy === 'b2c')?_c('div',[_vm._v("\n    "+_vm._s(_vm.row.dispatchTrackDistributionCenter)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9b4669e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderTable/components/tdDistribution.vue
// module id = e+1S
// module chunks = 0